// extracted by mini-css-extract-plugin
export default {"base":"icC3F","header":"h6Agl","disclosureArrow":"p_p7I","content":"f6T_W","expandLabel":"MceW_","usingExpandLabels":"bk0Ds","expanded":"tb2n8","large":"YDvY8","unlimited":"dPfoK"};